
export default class URL {
    static append(param, value) {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let param_array = [];
        for (const p of params) {
            if (p[0] !== 'query') {
                var p2 = p[0];
                if (p[1] !== "") {
                    p2 += "=" + p[1];
                }
                param_array.push(p2);
            }
        }
        params = "";
        if (param_array.length) {
            params = "&" + param_array.join('&');
        }
        window.history.pushState("", null, "?" + param + "=" + value + params); 
    }
}